import { BiLogoGithub, BiLogoLinkedin } from "react-icons/bi";
import { AiOutlineMail } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import profile2 from "../assets/profile2.png"
const Navbar = () => {
  const [isActive, setIsActive] = useState(false);
  const headerRef = useRef(null);
  const width = window.innerWidth;
  useEffect(() => {
    if (isActive === true) headerRef.current.classList.add("header-active");
    else headerRef.current.classList.remove("header-active");
  }, [isActive]);

  // Variants

  const navLinkVars = {
    initial: {
      y: "100",
      transition: {
        duration: 0.5,
        ease: [0.37, 0, 0.63, 1],
      },
    },
    open: {
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0, 0.55, 0.45, 1],
      },
    },
  };

  const containerVars = {
    initial: {
      transition: {
        staggerChildren: 0.09,
        staggerDirection: -1,
      },
    },
    open: {
      transition: {
        staggerChildren: 0.09,
        staggerDirection: 1,
      },
    },
  };

  return (
    <>
      {/* Hamburger */}
      <button className="hamburger" onClick={() => setIsActive(!isActive)}>
        <GiHamburgerMenu />
      </button>

      <div ref={headerRef} className="header">
        <div className="header-logo">
          <p>Rehan Shafqat</p>
        </div>


        <nav className="primary-nav"
          style={
            {
              marginTop: "-160px"
            }

          }

        >
          <motion.ul
            variants={containerVars}
            initial="initial"
            whileInView="open"
            className="nav-list"
            onClick={() => setIsActive(false)}
          >
            <div className="overflow-hidden">
              <motion.li variants={navLinkVars} className="nav-item">
                <a href="#home">Home</a>
              </motion.li>
            </div>
            <div className="overflow-hidden">
              <motion.li variants={navLinkVars} className="nav-item">
                <a href="#about">About</a>
              </motion.li>
            </div>
            <div className="overflow-hidden">
              <motion.li variants={navLinkVars} className="nav-item">
                <a href="#projects">Projects</a>
              </motion.li>
            </div>
            <div className="overflow-hidden">
              <motion.li variants={navLinkVars} className="nav-item">
                <a href="#contact">Contact</a>
              </motion.li>
            </div>
          </motion.ul>
        </nav>

        <footer className="footer">
          <ul className="footer-links">
            <li className="footer-item">
              <a href="https://github.com/RehanShafqat/" target="blank">
                <BiLogoGithub />
              </a>
            </li>
            <li className="footer-item" target="blank">
              <a href="https://www.linkedin.com/in/muhammad-rehan-shafqat-a93447256/">
                <BiLogoLinkedin />
              </a>
            </li>
            <li className="footer-item">
              <a href="mailto:rehanshafqat2004@gmail.com" target="blank">
                <AiOutlineMail />
              </a>
            </li>
          </ul>

          <div className="copyright">
            Copyright &copy; 2024. <br /> All rights reserved
          </div>
        </footer>
      </div>
    </>
  );
};

export default Navbar;
